













































import { Component, Inject, Vue } from 'vue-property-decorator'
import { CompanyAPI } from '@/api/backend-client'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'

@Component
export default class EmmaWidget extends Vue {

    @Inject() readonly reloadCompany: () => Promise<void>
    company: Company = null
    loading: boolean = false
    saving: boolean = false

    async created() {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.company = cloneDeep<Company>(this.$currentCompany)
        this.loading = false
    }

    async save(): Promise<void> {
        try {
            this.loading = true
            this.$root.$currentCompany = await CompanyAPI.updateWidgetSettings(this.company.id, this.company)

            await this.reload()
        } finally {
            this.loading = false
        }
    }
}
